import React from "react";
import { DISCLAIMER_TEXT } from "@/components/layout/Footer";

const SECTIONS = [
  {
    title: "Our privacy promise",
    body: [
      "Recovery participation is deeply personal. Sponsor Me is built so that you can find support without publishing your identity.",
      "We never require your full legal name, exact home address, employer, sobriety date, medical history or diagnosis. Profile photos are always optional, and a display name such as 'Mike R.' is enough.",
    ],
  },
  {
    title: "What we collect",
    list: [
      "Account basics: email address, display name, hashed password",
      "Optional profile details you choose to add: first name, photo, recovery pathway, general location (city, state, country), language, gender, short introduction",
      "Sponsor profile content you write: about me, approach, availability, communication preferences",
      "Activity needed to run the service: sponsorship requests, conversations, messages, favorites, blocks, reports, notifications",
      "Billing records from Stripe: customer and subscription identifiers, plan, status and renewal dates. We never see or store your full card number.",
    ],
  },
  {
    title: "What we never show publicly",
    list: [
      "Your email address",
      "Your phone number (phone numbers are never displayed publicly, even if you list phone as a contact preference)",
      "Your exact street address or precise location",
      "Your sobriety date, medical history or diagnosis",
      "The contents of your private messages",
    ],
  },
  {
    title: "Messages and security",
    body: [
      "Private messages are transmitted over HTTPS/TLS and stored in our database with access restricted to the platform. Passwords are stored only as one-way hashes.",
      "Moderators may review specific messages when a member reports them, strictly for safety review.",
    ],
  },
  {
    title: "Notifications",
    body: [
      "In-app notifications tell you about sponsorship requests, new messages, and favorited sponsors opening availability. Email notifications are optional, and by default we never include the contents of private messages in an email.",
    ],
  },
  {
    title: "Availability alert requests",
    body: [
      "If a sponsor search returns no results, you can optionally ask us to tell you when a sponsor becomes available. We store only two things for that: the email address you type in and the recovery pathway you select. No account is required, and nothing else about you is collected.",
      "We only store it when you tick the consent box yourself - it is never pre-ticked - and we keep a record of the exact sentence you agreed to and the time you agreed to it. These requests are visible to Sponsor Me administrators only. They are never shown publicly, never added to a marketing list, and the email address and pathway are never sent to our analytics provider or any other third party.",
      "Availability alerts are not switched on yet, because we do not have an email provider configured. Your request is held until they are, and when alerts do start they are reviewed and sent by an administrator rather than triggered automatically. You can unsubscribe or delete the request at any time - deleting it removes the email address and the pathway entirely.",
    ],
  },
  {
    title: "Your choices",
    list: [
      "Edit or remove any optional profile information at any time",
      "Pause your sponsor profile to hide it from the directory",
      "Block or report any member, free of charge",
      "Unsubscribe from, or permanently delete, an availability alert request",
      "Delete your account, which removes your profile and anonymises your data",
    ],
  },
  {
    title: "Third parties",
    body: [
      "We use Stripe to process subscription payments. Stripe handles card data directly under its own privacy policy. We do not sell your personal information, and we do not share your recovery details with advertisers.",
    ],
  },
  {
    title: "Independence",
    body: [DISCLAIMER_TEXT],
  },
];

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="font-display text-4xl font-bold text-[#1F2A2E]">Privacy Policy</h1>
      <p className="mt-2 text-sm text-[#7A868B]">Last updated {new Date().toLocaleDateString()}</p>
      <div className="mt-8 space-y-8">
        {SECTIONS.map((s) => (
          <section key={s.title}>
            <h2 className="font-display text-xl font-bold text-[#1F2A2E]">{s.title}</h2>
            {(s.body || []).map((p, i) => (
              <p key={`${s.title}-p${i}`} className="mt-3 text-[#4B5A60] leading-7">
                {p}
              </p>
            ))}
            {s.list ? (
              <ul className="mt-3 space-y-1.5 list-disc pl-5 text-[#4B5A60] leading-7">
                {s.list.map((l) => (
                  <li key={l}>{l}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </div>
    </div>
  );
}
